import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../../url_variables';
import { TostMessageContext } from "../../context/TostMessage";
import ReactLoading from 'react-loading';
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { BiWallet } from "react-icons/bi";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import { SideMenu } from '../../components/sidebar';
import { TopBar } from '../../components/topbar';
import {ButtonBlack, ButtonSmall} from '../../components/buttons';
import { RouteDisplay } from '../../components/route_display';
import { UserContext } from '../../context/UserContext';
import { IoLibraryOutline } from 'react-icons/io5';
import ProgressBarComponent from '../../components/progess_bar'
import { ClockLoader } from 'react-spinners';
import { PiHandWithdraw } from 'react-icons/pi';
import { FaChildren, FaUsersBetweenLines, FaChild, FaMoneyBillTransfer } from 'react-icons/fa6';
import Chart from "react-apexcharts";
import { FaSwatchbook } from "react-icons/fa";


function RevenueOverviewScreen() {
    const navigate = useNavigate();
    const [cookies] = useCookies();
    const [loadingClasses, setLoadingClasses] = useState(false);
    const { setTostMessage } = useContext(TostMessageContext);
    const {logOutFunction, calendarValues, setCalendarValues, userProfile} = useContext(UserContext);
    const [profileData, setProfileData] = useState({ });
    const [chartData, setChartData] = useState({xaxis: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'], data: [], colors: [], lang_performance_label: [], lang_performance_series: [], tutor_rev_label: [], tutor_rev_series: [], tutor_earn_label: [], tutor_earn_series: [], book_sales_series: [], book_sales_label: []});
    const location = useLocation();

    useEffect(() => {
        getClasses();
    }, [])

    const getClasses = async () => {
        setLoadingClasses(true);
        try {
            const response = await axios.get(base_url + '/revenue/fetch_financial_report.php', {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    main_id: cookies?.userProfile?.main_id,
                    sub_id: cookies?.userProfile?.sub_id
                },
            });
            if (response.data.code == 403) {
                setLoadingClasses(false);
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
                logOutFunction()
            }
            if (response.data.status) {
                setLoadingClasses(false);
                setChartData({ xaxis: response.data.data.dates, data: response.data.data.credit_data, colors: response.data.data.colors, lang_performance_label: response.data.data.lang_performance.label, lang_performance_series: response.data.data.lang_performance.series, tutor_rev_series: response.data.data.tutor_revenue.series, tutor_rev_label: response.data.data.tutor_revenue.label, tutor_earn_label: response.data.data.tutor_earnings.label, tutor_earn_series: response.data.data.tutor_earnings.series, book_sales_label: response.data.data.book_sales.label, book_sales_series: response.data.data.book_sales.series })
                setProfileData({'total_credits': response.data.data.total_credits, 'total_private_credits': response.data.data.total_private_credits, 'total_shop_sales': response.data.data.total_shop_sales, 'total_debits': response.data.data.total_debits, 'student_count': response.data.data.student_count, 'classes_count': response.data.data.classes_count });
            } else {
                setLoadingClasses(false);
                setTostMessage({
                    messageType: "error",
                    message: response.data.response,
                });
            }
        } catch (error) {
            setLoadingClasses(false);
            setTostMessage({
                messageType: "error",
                message: 'Network error',
            });
        }
    }

  return (
    <div className="relative h-screen h-full">
        <div className="flex h-screen bg-white">
            {/* Sidebar */}
            <SideMenu />
            {/* Main content */}
            <main className="flex-1 p-8 overflow-y-auto">
                {/* Header */}
                <TopBar />
                <RouteDisplay />
                <div className='w-full flex flex-row justify-between'>
                    {loadingClasses ? (
                        <div className='flex justify-center items-center w-fill-available h-full z-[999999] bg-[#ffffff] opacity-[0.6] fixed top-0'>
                            <ClockLoader
                                color={'#F4D00F'}
                                loading={loadingClasses}
                                size={60}
                                aria-label="Loading Spinner"
                                data-testid="loader1"
                            />
                        </div>
                    ) : (
                    <div className="w-full lg:w-[100%] p-0 lg:p-3 space-y-6 min-h-screen">
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                            <div  className="flex flex-row gap-x-2 p-4 items-center justify-start bg-white shadow rounded-xl p-4 py-6 text-center border border-1 border-[#bbb]">
                                <div className='bg-gradient-to-r from-dark to-yellow rounded-full p-2 md:p-4 bg-[#ff0000] mr-2 md:mr-4'>
                                    <FaChildren size={20} color='#fff' />
                                </div>
                                <div className='flex flex-col justify-start items-start'>
                                    <div className="text-[12px] font-semibold text-dark">{'Group Classes'}</div>
                                    <div className="text-[17px] md:text-[25px] font-semibold text-yellow">{profileData?.total_credits}</div>
                                    <div onClick={() => navigate('/revenue/group-subs')} className="text-xs cursor-pointer underline text-dark mt-2">View</div>
                                </div>
                            </div>
                            <div  className="flex flex-row p-4 items-center justify-start bg-white shadow rounded-xl p-4 py-6 text-center border border-1 border-[#bbb]">
                                <div className='bg-gradient-to-r from-dark to-yellow rounded-full p-2 md:p-4 bg-[#ff0000] mr-2 md:mr-4'>
                                    <FaChild size={20} color='#fff' />
                                </div>
                                <div className='flex flex-col justify-start items-start'>
                                    <div className="text-[12px] font-semibold text-dark">{'Private Classes'}</div>
                                    <div className="text-[17px] md:text-[25px] font-semibold text-yellow">{profileData?.total_private_credits}</div>
                                    <div onClick={() => navigate('/revenue/private-subs')} className="text-xs cursor-pointer underline text-dark mt-2">View</div>
                                </div>
                            </div>
                            <div  className="flex flex-row p-4 items-center justify-start bg-white shadow rounded-xl p-4 py-6 text-center border border-1 border-[#bbb]">
                                <div className='bg-gradient-to-r from-dark to-yellow rounded-full p-2 md:p-4 bg-[#ff0000] mr-2 md:mr-4'>
                                    <FaSwatchbook size={20} color='#fff' />
                                </div>
                                <div className='flex flex-col justify-start items-start'>
                                    <div className="text-[12px] font-semibold text-dark">{'Book Sales'}</div>
                                    <div className="text-[17px] md:text-[25px] font-semibold text-yellow">{profileData?.total_shop_sales}</div>
                                    <div onClick={() => navigate('/shop-sales')} className="text-xs cursor-pointer underline text-dark mt-2">View</div>
                                </div>
                            </div>
                            <div  className="flex flex-row p-4 items-center justify-start bg-white shadow rounded-xl p-4 py-6 text-center border border-1 border-[#bbb]">
                                <div className='bg-gradient-to-r from-dark to-yellow rounded-full p-2 md:p-4 bg-[#ff0000] mr-2 md:mr-4'>
                                    <FaMoneyBillTransfer size={20} color='#fff' />
                                </div>
                                <div className='flex flex-col justify-start items-start'>
                                    <div className="text-[12px] font-semibold text-dark">{'Tutor Payouts'}</div>
                                    <div className="text-[17px] md:text-[25px] font-semibold text-yellow">{profileData?.total_debits}</div>
                                    {/* <div onClick={() => navigate('/my-students')} className="text-xs cursor-pointer underline text-[#000aff] mt-2">View</div> */}
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex flex-col md:flex-row justify-between'>
                            <div className="bg-white rounded-xl p-3 md:p-6 w-full border border-1 border-[#ebebeb]">
                                <div className="flex justify-between mb-4">
                                    <h2 className="font-semibold text-lg">Overview</h2>
                                    <span className="text-sm text-yellow-500 cursor-pointer">Last 12 Months</span>
                                </div>
                                <div className="flex items-end gap-3 h-auto w-full">
                                    <div className="mixed-chart w-full">
                                        <Chart
                                        options={{
                                            chart: {
                                                id: "basic-bar",
                                                toolbar: { show: true },
                                            },
                                            plotOptions: {
                                                bar: {
                                                borderRadius: 2,
                                                border: 3,
                                                borderColor: '#585858',
                                                columnWidth: '40%',
                                                distributed: true, // So you can color individual bars
                                                },
                                            },
                                            colors: chartData?.colors,
                                            dataLabels: {
                                                enabled: false,
                                            },
                                            legend: {
                                                show: false
                                            },
                                            grid: {
                                                show: true,
                                                borderColor: '#E5E7EB', // Tailwind gray-200
                                                strokeDashArray: 1,
                                                padding: { top: 0, right: 0, bottom: 0, left: 0 },
                                            },
                                            xaxis: {
                                                categories: chartData?.xaxis,
                                                axisBorder: { show: true },
                                                axisTicks: { show: true },
                                                labels: {
                                                    style: {
                                                        colors: '#212121', // Tailwind gray-500
                                                        fontSize: '8px',
                                                    },
                                                },
                                            },
                                            yaxis: {
                                                labels: {
                                                    style: {
                                                        colors: '#212121', // Tailwind gray-400
                                                        fontSize: '8px',
                                                    },
                                                },
                                                axisBorder: { show: false },
                                                axisTicks: { show: false },
                                            },
                                        }}
                                        series={[
                                            {
                                                name: 'Overall Earnings ($)',
                                                data: chartData?.data
                                            }
                                        ]}
                                        type="bar"
                                        height="300"
                                        // width="500"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='w-full grid grid-cols-1 md:grid-cols-4 gap-4'>
                            <div className="bg-white h-full rounded-xl py-6 w-full border border-1 border-[#ebebeb]">
                                <div className="flex justify-between mb-4 px-3 md:px-6">
                                    <h2 className="font-semibold text-lg">Revenue By Language</h2>
                                </div>
                                <div className='w-full flex items-center justify-center'>
                                    <Chart
                                        options={{
                                            chart: {
                                                type: "donut",
                                            },
                                            labels: chartData?.lang_performance_label,
                                            legend: {
                                                position: "bottom",
                                            },
                                            theme: {
                                                palette: 'palette4' // built-in palettes: palette1, palette2, etc.
                                            },
                                            dataLabels: {
                                                enabled: true,
                                                style: {
                                                    fontSize: "12px",
                                                    fontWeight: "bold",
                                                    colors: ["#fff"]
                                                },
                                                dropShadow: {
                                                    enabled: true,
                                                    top: 2,
                                                    left: 2,
                                                    blur: 4,
                                                    opacity: 0.8
                                                }
                                            },
                                            legend: {
                                                show: false,
                                            },
                                            tooltip: {
                                                enabled: true,
                                                fillSeriesColor: false,
                                                y: {
                                                    formatter: (val) => `${val} $`
                                                }
                                            },
                                            plotOptions: {
                                                pie: {
                                                    expandOnClick: true,
                                                    donut: {
                                                        size: "40%",
                                                        labels: {
                                                            show: true,
                                                            name: {
                                                                show: false,
                                                                fontSize: "14px",
                                                                fontWeight: 600,
                                                                color: "#333"
                                                            },
                                                            value: {
                                                                show: true,
                                                                fontSize: "14px",
                                                                fontWeight: 400,
                                                                color: "#666",
                                                                formatter: (val) => val + "%"
                                                            },
                                                            total: {
                                                                show: true,
                                                                label: "Total",
                                                                fontSize: "18px",
                                                                color: "#111",
                                                                fontWeight: 700,
                                                                formatter: (w) =>
                                                                    w.globals.seriesTotals.reduce((a, b) => a + b, 0) + ' $'
                                                            },
                                                        },
                                                    },
                                                },
                                            },
                                        }}
                                        series={chartData?.lang_performance_series}
                                        type="donut"
                                        width={250}
                                    />
                                </div>
                            </div>
                            <div className="bg-white h-full rounded-xl py-6 w-full border border-1 border-[#ebebeb]">
                                <div className="flex justify-between mb-4 px-3 md:px-6">
                                    <h2 className="font-semibold text-lg">Revenue By Tutor</h2>
                                </div>
                                <div className='w-full flex items-center justify-center'>
                                    <Chart
                                        options={{
                                            chart: {
                                                type: "donut",
                                            },
                                            labels: chartData?.tutor_rev_label,
                                            legend: {
                                                position: "bottom",
                                            },
                                            theme: {
                                                palette: 'palette2' // built-in palettes: palette1, palette2, etc.
                                            },
                                            dataLabels: {
                                                enabled: true,
                                                style: {
                                                    fontSize: "12px",
                                                    fontWeight: "bold",
                                                    colors: ["#fff"]
                                                },
                                                dropShadow: {
                                                    enabled: true,
                                                    top: 2,
                                                    left: 2,
                                                    blur: 4,
                                                    opacity: 0.8
                                                }
                                            },
                                            legend: {
                                                show: false,
                                            },
                                            tooltip: {
                                                enabled: true,
                                                fillSeriesColor: false,
                                                y: {
                                                    formatter: (val) => `${val} $`
                                                }
                                            },
                                            plotOptions: {
                                                pie: {
                                                    expandOnClick: true,
                                                    donut: {
                                                        size: "40%",
                                                        labels: {
                                                            show: true,
                                                            name: {
                                                                show: false,
                                                                fontSize: "14px",
                                                                fontWeight: 600,
                                                                color: "#333"
                                                            },
                                                            value: {
                                                                show: true,
                                                                fontSize: "14px",
                                                                fontWeight: 400,
                                                                color: "#666",
                                                                formatter: (val) => val + "%"
                                                            },
                                                            total: {
                                                                show: true,
                                                                label: "Total",
                                                                fontSize: "18px",
                                                                color: "#111",
                                                                fontWeight: 700,
                                                                formatter: (w) =>
                                                                    w.globals.seriesTotals.reduce((a, b) => a + b, 0) + ' $'
                                                            },
                                                        },
                                                    },
                                                },
                                            },
                                        }}
                                        series={chartData?.tutor_rev_series}
                                        type="donut"
                                        width={250}
                                    />
                                </div>
                            </div>
                            <div className="bg-white h-full rounded-xl py-6 w-full border border-1 border-[#ebebeb]">
                                <div className="flex justify-between mb-4 px-3 md:px-6">
                                    <h2 className="font-semibold text-lg">Highest Earning Tutors</h2>
                                </div>
                                <div className='w-full flex items-center justify-center'>
                                    <Chart
                                        options={{
                                            chart: {
                                                type: "donut",
                                            },
                                            labels: chartData?.tutor_earn_label,
                                            legend: {
                                                position: "bottom",
                                            },
                                            theme: {
                                                palette: 'palette3' // built-in palettes: palette1, palette2, etc.
                                            },
                                            dataLabels: {
                                                enabled: true,
                                                style: {
                                                    fontSize: "12px",
                                                    fontWeight: "bold",
                                                    colors: ["#fff"]
                                                },
                                                dropShadow: {
                                                    enabled: true,
                                                    top: 2,
                                                    left: 2,
                                                    blur: 4,
                                                    opacity: 0.8
                                                }
                                            },
                                            legend: {
                                                show: false,
                                            },
                                            tooltip: {
                                                enabled: true,
                                                fillSeriesColor: false,
                                                y: {
                                                    formatter: (val) => `${val} $`
                                                }
                                            },
                                            plotOptions: {
                                                pie: {
                                                    expandOnClick: true,
                                                    donut: {
                                                        size: "40%",
                                                        labels: {
                                                            show: true,
                                                            name: {
                                                                show: false,
                                                                fontSize: "14px",
                                                                fontWeight: 600,
                                                                color: "#333"
                                                            },
                                                            value: {
                                                                show: true,
                                                                fontSize: "14px",
                                                                fontWeight: 400,
                                                                color: "#666",
                                                                formatter: (val) => val + "%"
                                                            },
                                                            total: {
                                                                show: true,
                                                                label: "Total",
                                                                fontSize: "18px",
                                                                color: "#111",
                                                                fontWeight: 700,
                                                                formatter: (w) =>
                                                                    w.globals.seriesTotals.reduce((a, b) => a + b, 0) + ' $'
                                                            },
                                                        },
                                                    },
                                                },
                                            },
                                        }}
                                        series={chartData?.tutor_earn_series}
                                        type="donut"
                                        width={250}
                                    />
                                </div>
                            </div>
                            <div className="bg-white h-full rounded-xl py-6 w-full border border-1 border-[#ebebeb]">
                                <div className="flex justify-between mb-4 px-3 md:px-6">
                                    <h2 className="font-semibold text-lg">Best Sellers (Books)</h2>
                                </div>
                                <div className='w-full flex items-center justify-center'>
                                    <Chart
                                        options={{
                                            chart: {
                                                type: "donut",
                                            },
                                            labels: chartData?.book_sales_label,
                                            legend: {
                                                position: "bottom",
                                            },
                                            theme: {
                                                palette: 'palette5' // built-in palettes: palette1, palette2, etc.
                                            },
                                            dataLabels: {
                                                enabled: true,
                                                style: {
                                                    fontSize: "12px",
                                                    fontWeight: "bold",
                                                    colors: ["#fff"]
                                                },
                                                dropShadow: {
                                                    enabled: true,
                                                    top: 2,
                                                    left: 2,
                                                    blur: 4,
                                                    opacity: 0.8
                                                }
                                            },
                                            legend: {
                                                show: false,
                                            },
                                            tooltip: {
                                                enabled: true,
                                                fillSeriesColor: false,
                                                y: {
                                                    formatter: (val) => `${val} $`
                                                }
                                            },
                                            plotOptions: {
                                                pie: {
                                                    expandOnClick: true,
                                                    donut: {
                                                        size: "40%",
                                                        labels: {
                                                            show: true,
                                                            name: {
                                                                show: false,
                                                                fontSize: "14px",
                                                                fontWeight: 600,
                                                                color: "#333"
                                                            },
                                                            value: {
                                                                show: true,
                                                                fontSize: "14px",
                                                                fontWeight: 400,
                                                                color: "#666",
                                                                formatter: (val) => val + "%"
                                                            },
                                                            total: {
                                                                show: true,
                                                                label: "Total",
                                                                fontSize: "18px",
                                                                color: "#111",
                                                                fontWeight: 700,
                                                                formatter: (w) =>
                                                                    w.globals.seriesTotals.reduce((a, b) => a + b, 0) + ' $'
                                                            },
                                                        },
                                                    },
                                                },
                                            },
                                        }}
                                        series={chartData?.book_sales_series}
                                        type="donut"
                                        width={250}
                                    />
                                </div>
                            </div>                           
                        </div>
                    </div>
                    )}
                </div>
            </main>
        </div>
    </div>
  );
}

export default RevenueOverviewScreen;
